"use strict";
exports.__esModule = true;
exports.Authorizer = exports.canRemoveUser = exports.canEditUserGroup = exports.canEditUserEmail = exports.canEditUser = void 0;
var authGroups_1 = require("./authGroups");
var user_1 = require("./user");
var users_1 = require("./users");
var permission_1 = require("./permission");
var _getSurveyUserGroup = function (user, survey, includeSystemAdmin) {
    if (includeSystemAdmin === void 0) { includeSystemAdmin = true; }
    return users_1.Users.getAuthGroupBySurveyUuid(survey.uuid, includeSystemAdmin)(user);
};
var _hasSurveyPermission = function (permission) { return function (user, survey) {
    var _a, _b;
    return user &&
        survey &&
        (users_1.Users.isSystemAdmin(user) || Boolean((_b = (_a = _getSurveyUserGroup(user, survey)) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.includes(permission)));
}; };
var canViewSurvey = function (user, survey) { return Boolean(_getSurveyUserGroup(user, survey)); };
var canEditSurvey = _hasSurveyPermission(permission_1.Permission.surveyEdit);
var canCreateRecord = _hasSurveyPermission(permission_1.Permission.recordCreate);
var canViewRecord = _hasSurveyPermission(permission_1.Permission.recordView);
var canEditRecord = function (user, record) {
    if (users_1.Users.isSystemAdmin(user)) {
        return true;
    }
    if (!(user && record)) {
        return false;
    }
    var recordDataStep = record.step, recordSurveyUuid = record.surveyUuid;
    var userAuthGroup = users_1.Users.getAuthGroupBySurveyUuid(recordSurveyUuid)(user);
    var level = authGroups_1.AuthGroups.getRecordEditLevel(recordDataStep)(userAuthGroup);
    return level === permission_1.RecordStepPermission.all || (level === permission_1.RecordStepPermission.own && record.ownerUuid === user.uuid);
};
var canCleanseRecords = _hasSurveyPermission(permission_1.Permission.recordCleanse);
var canAnalyzeRecords = _hasSurveyPermission(permission_1.Permission.recordAnalyse);
var canInviteUsers = _hasSurveyPermission(permission_1.Permission.userInvite);
var canViewUser = function (user, survey, userToView) {
    return users_1.Users.isSystemAdmin(user) ||
        Boolean(_getSurveyUserGroup(user, survey, false) && _getSurveyUserGroup(userToView, survey, false));
};
var _hasSurveyUserGroup = function (user, survey) { return Boolean(_getSurveyUserGroup(user, survey, false)); };
var _hasUserEditAccess = function (user, survey, userToUpdate) {
    return users_1.Users.isSystemAdmin(user) ||
        (_hasSurveyPermission(permission_1.Permission.userEdit)(user, survey) && _hasSurveyUserGroup(userToUpdate, survey));
};
var canEditUser = function (user, survey, userToUpdate) {
    return Boolean(userToUpdate.status === user_1.UserStatus.ACCEPTED &&
        (user.uuid === userToUpdate.uuid || _hasUserEditAccess(user, survey, userToUpdate)));
};
exports.canEditUser = canEditUser;
exports.canEditUserEmail = _hasUserEditAccess;
var canEditUserGroup = function (user, survey, userToUpdate) {
    return Boolean(user.uuid !== userToUpdate.uuid && _hasUserEditAccess(user, survey, userToUpdate));
};
exports.canEditUserGroup = canEditUserGroup;
var canRemoveUser = function (user, survey, userToRemove) {
    return Boolean(user.uuid !== userToRemove.uuid &&
        !users_1.Users.isSystemAdmin(userToRemove) &&
        _hasUserEditAccess(user, survey, userToRemove));
};
exports.canRemoveUser = canRemoveUser;
exports.Authorizer = {
    canViewSurvey: canViewSurvey,
    canEditSurvey: canEditSurvey,
    canCreateRecord: canCreateRecord,
    canViewRecord: canViewRecord,
    canEditRecord: canEditRecord,
    canCleanseRecords: canCleanseRecords,
    canAnalyzeRecords: canAnalyzeRecords,
    canInviteUsers: canInviteUsers,
    canViewUser: canViewUser,
    canEditUser: exports.canEditUser,
    canEditUserEmail: exports.canEditUserEmail,
    canEditUserGroup: exports.canEditUserGroup,
    canRemoveUser: exports.canRemoveUser
};
//# sourceMappingURL=authorizer.js.map